function Sign({ fetched }) {
    const color = fetched ? "#00FFA3" : "#ff3e30";

    return (
        <div style={{
            width: "12px",
            height: "12px",
            borderRadius: "50%",
            backgroundColor: color,
            marginTop: "2px",
        }}>
        </div>
    );
}

export default Sign;